import i18n from "../../i18n";

export const dashboardBlocksConfig = [
  {
    id: "bloc0",
    get title() {
      return i18n.t("dashboard.config.bloc0.title", "Bloc 0 · Context ambiental");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc0.description",
        "Mesures inicials de context: temperatura del sòl, temperatura ambient i dies des de la pluja."
      );
    },
    fields: [
      {
        key: "temperatureSoil",
        get label() {
          return i18n.t("dashboard.blocks.bloc0.soilTemp", "Temperatura del sòl");
        },
        kind: "numeric",
      },
      {
        key: "temperatureAmbient",
        get label() {
          return i18n.t("dashboard.blocks.bloc0.ambientTemp", "Temperatura ambient");
        },
        kind: "numeric",
      },
      {
        key: "daysSinceRain",
        get label() {
          return i18n.t("dashboard.blocks.bloc0.daysSinceRain", "Dies des de la pluja");
        },
        kind: "numeric",
      },
    ],
  },
  {
    id: "bloc1",
    get title() {
      return i18n.t("dashboard.config.bloc1.title", "Bloc 1 · Sòl i pH");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc1.description",
        "Tipologia del sòl, mesura de pH i observacions associades."
      );
    },
    fields: [
      {
        key: "soilType",
        get label() {
          return i18n.t("dashboard.blocks.bloc1.soilType", "Tipologia del sòl");
        },
        kind: "categorical",
      },
      { key: "phLevel", label: "pH", kind: "numeric" },
    ],
  },
  {
    id: "bloc2",
    get title() {
      return i18n.t("dashboard.config.bloc2.title", "Bloc 2 · Vegetació");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc2.description",
        "Presència de vegetació, plantes, arbres i altres elements vegetals."
      );
    },
    fields: [
      {
        key: "vegetation",
        get label() {
          return i18n.t("dashboard.config.bloc2.vegetationLabel", "Hi ha vegetació?");
        },
        kind: "boolean",
      },
      {
        key: "plantType",
        get label() {
          return i18n.t("dashboard.blocks.bloc2.plantTypes", "Tipus de plantes");
        },
        kind: "categorical",
      },
    ],
  },
  {
    id: "bloc3",
    get title() {
      return i18n.t("dashboard.config.bloc3.title", "Bloc 3 · Roca i minerals");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc3.description",
        "Observació de roques, pedres i minerals presents a l’entorn."
      );
    },
    fields: [
      {
        key: "rockBool",
        get label() {
          return i18n.t("dashboard.config.bloc3.rockBoolLabel", "Hi ha roques o pedres?");
        },
        kind: "boolean",
      },
      {
        key: "rockCategory",
        get label() {
          return i18n.t("dashboard.config.bloc3.rockCategoryLabel", "Categoria de roca");
        },
        kind: "categorical",
      },
      {
        key: "mineralBool",
        get label() {
          return i18n.t("dashboard.config.bloc3.mineralBoolLabel", "Hi ha minerals?");
        },
        kind: "boolean",
      },
      {
        key: "mineralCategory",
        get label() {
          return i18n.t("dashboard.config.bloc3.mineralCategoryLabel", "Categoria de mineral");
        },
        kind: "categorical",
      },
    ],
  },
  {
    id: "bloc4",
    get title() {
      return i18n.t("dashboard.config.bloc4.title", "Bloc 4 · Animals");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc4.description",
        "Presència d’animals i classificació bàsica per categoria."
      );
    },
    fields: [
      {
        key: "animalBool",
        get label() {
          return i18n.t("dashboard.config.bloc4.animalBoolLabel", "Hi ha animals?");
        },
        kind: "boolean",
      },
      {
        key: "animalCategory",
        get label() {
          return i18n.t("dashboard.config.bloc4.animalCategoryLabel", "Categoria d’animals");
        },
        kind: "categorical",
      },
    ],
  },
  {
    id: "bloc5",
    get title() {
      return i18n.t("dashboard.config.bloc5.title", "Bloc 5 · Residus");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc5.description",
        "Observació de residus i classificació de les deixalles detectades."
      );
    },
    fields: [
      {
        key: "wasteObserved",
        get label() {
          return i18n.t("dashboard.config.bloc5.wasteObservedLabel", "Hi ha residus?");
        },
        kind: "boolean",
      },
      {
        key: "wasteCategory",
        get label() {
          return i18n.t("dashboard.config.bloc5.wasteCategoryLabel", "Categoria de residus");
        },
        kind: "categorical",
      },
    ],
  },
  {
    id: "bloc6",
    get title() {
      return i18n.t("dashboard.config.bloc6.title", "Bloc 6 · Fongs i microorganismes");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc6.description",
        "Presència de fongs, líquens i bacteris observats al medi."
      );
    },
    fields: [
      {
        key: "fungiBool",
        get label() {
          return i18n.t("dashboard.config.bloc6.fungiBoolLabel", "Hi ha fongs?");
        },
        kind: "boolean",
      },
      {
        key: "fungiType",
        get label() {
          return i18n.t("dashboard.blocks.bloc6.fungiTypes", "Tipus de fongs");
        },
        kind: "categorical",
      },
      {
        key: "lichenBool",
        get label() {
          return i18n.t("dashboard.config.bloc6.lichenBoolLabel", "Hi ha líquens?");
        },
        kind: "boolean",
      },
      {
        key: "lichenType",
        get label() {
          return i18n.t("dashboard.blocks.bloc6.lichenTypes", "Tipus de líquens");
        },
        kind: "categorical",
      },
      {
        key: "bacteriaBool",
        get label() {
          return i18n.t("dashboard.config.bloc6.bacteriaBoolLabel", "Hi ha bacteris?");
        },
        kind: "boolean",
      },
      {
        key: "bacteriaType",
        get label() {
          return i18n.t("dashboard.blocks.bloc6.bacteriaTypes", "Tipus de bacteris");
        },
        kind: "categorical",
      },
    ],
  },
  {
    id: "bloc7",
    get title() {
      return i18n.t("dashboard.config.bloc7.title", "Bloc 7 · Aigua");
    },
    get description() {
      return i18n.t(
        "dashboard.config.bloc7.description",
        "Presència d’aigua i variables físiques i biològiques associades."
      );
    },
    fields: [
      {
        key: "waterBool",
        get label() {
          return i18n.t("dashboard.config.bloc7.waterBoolLabel", "Hi ha aigua?");
        },
        kind: "boolean",
      },
      {
        key: "waterSource",
        get label() {
          return i18n.t("dashboard.blocks.bloc7.waterSource", "Procedència de l’aigua");
        },
        kind: "categorical",
      },
      {
        key: "waterTemperature",
        get label() {
          return i18n.t("dashboard.blocks.bloc7.waterTemperature", "Temperatura de l’aigua");
        },
        kind: "numeric",
      },
      {
        key: "waterPH",
        get label() {
          return i18n.t("dashboard.blocks.bloc7.waterPh", "pH de l’aigua");
        },
        kind: "numeric",
      },
    ],
  },
];
